const DOC = '.doc',
  DOCX = '.docx',
  PDF = '.pdf',
  UNKNOWN = '',
  ALL = [DOC, DOCX, PDF];

function getFileExtension(fileName) {
  if (typeof fileName !== 'string') {
    return UNKNOWN;
  }
  const splitted = fileName.split('.');
  if (splitted.length <= 1) {
    return UNKNOWN;
  }

  const extension = '.' + splitted[splitted.length - 1].toLowerCase();
  return ALL.includes(extension) ? extension : UNKNOWN;
}

function isExtensionValide(name, extensionsAutorisees) {
  const fileExtension = getFileExtension(name);
  return extensionsAutorisees.includes(fileExtension);
}

export default {
  DOC: DOC,
  DOCX: DOCX,
  PDF: PDF,
  UNKNOWN: UNKNOWN,
  ALL: ALL,
  getFileExtension: getFileExtension,
  isExtensionValide: isExtensionValide
};
